import EventScorekeeping from '@/screens/EventScorekeeping';

export default function PrivateTabsEventEventIdScoreRoute() {
  return <EventScorekeeping basePath="/event" />;
}
